<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.sidemenu.faq" sideMenu></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy" rounded>
            <div class="px-5">
                <div class="list-faq-group">
                    <template v-for="(g, idx) of faqGroup" :key="`faq-g-${idx}`">
                        <div
                            class="flex items-start first:pt-0 py-4 border-b"
                            @click="openDetail(g.id, g.groupName)"
                        >
                            <div class="flex-none">
                                <img src="@/assets/icon/misc/pin.svg" class="pt-1" alt />
                            </div>
                            <div class="flex-auto mx-3 text-gray-700">{{ g.groupName }}</div>
                            <div class="flex-none self-center">
                                <img
                                    class="w-4 h-4 transform"
                                    src="@/assets/icon/arrow/arrow-chevron-right.svg"
                                    alt
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </PageContent>
        <ButtonFBMessenger :text="lbl.faq.fb"></ButtonFBMessenger>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>
    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import ConfigManager from "@/config/ConfigManager.js";
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"
import ButtonFBMessenger from "../component/ButtonFBMessenger.vue"

// mixin
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"
import PdpaMixin from "@/mixin/PdpaMixin";

// service
import BzbsService from '@/core/Custom/service/CustomService';

export default {
    name: "FAQPage",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, PdpaMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        ModalMaster,
        ButtonFBMessenger,
    },
    data: function () {
        return {
            hasPoweredBy: false,
            dialogFAQ: false,
            faq_config_file: 'FAQ.json',
            faqGroup: [],
            trackingScreenName: 'faq',
        }
    },
    created: function () {
        this.initFaq();
    },
    mounted: function () {
        this.tracking.screenName(this.trackingScreenName);
    },
    methods: {
        initFaq: function(){
            const url = ConfigManager.getBlobUrl()  + '/webconfig/jcb/' + this.localeCode + '/' + this.faq_config_file;
            BzbsService.apiGetBlobContent(url).subscribe(
                {
                    next: (data) => {
                        this.faqGroup = data;
                    },
                    error: (err) => {
                        this.errorApi(err)
                    }
                }
            )
        },
        openDetail: function (key, name) {
            this.tracking.event('question_group', 'click_question_group', name, null);
            this.$router.push({
                name: "faq-detail",
                params: {
                    key: key
                }
            })
            // this.dialogFAQ = true
        }
    }
}
</script>

